


  
  

  var faLightEarthAmericasUser = {
    prefix: 'fak',
    iconName: 'light-earth-americas-user',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M32 256c0 123.7 100.3 224 224 224c22.3 0 43.8-3.3 64.2-9.3c-.1 1.9-.1 3.7-.2 5.6l0 1.2c.1 8.8 1.9 17.3 5.1 25c-22.2 6.2-45.4 9.5-69.1 9.5c-91.5 0-176-48.8-221.7-128s-45.7-176.8 0-256S164.5 0 256 0s176 48.8 221.7 128c6 10.3 11.1 21 15.6 31.8c-11.3 .3-22.2 2.2-32.5 5.6c-.4-.8-.7-1.6-1.1-2.4l-41.8 16.7c-7.8 3.1-11.9 11.9-9.2 19.9l.5 1.4c-9.3 11.4-16.4 24.6-20.6 39l-10.2-30.5c-8-24.1 4.1-50.3 27.7-59.7l38.2-15.3C405 73.8 337.1 33.2 259.6 32l7 12.5c10.1 17.7 8 39.7-5.2 55.1l-20.1 23.5c-2.6 2.9-2.6 7.3-.1 10.3l17.9 21.5c9.9 11.9 10.8 29 2.2 41.9c-8.8 13.1-25.3 18.8-40.3 13.8l-24.2-8.1c-2.3-.8-4.9-.6-7.1 .5c-4.6 2.3-6.5 7.9-4.2 12.5l.7 1.4c1 2.1 2.7 3.8 4.8 4.8l45.9 22.9c4.4 2.2 9.3 3.4 14.3 3.4l48.8 0c17 0 33.3 6.7 45.3 18.7l3.9 3.9c12 12 18.7 28.3 18.7 45.3l0 8.3c0 23-12.3 44.2-32.2 55.6l-11.6 6.6c-9.1 5.2-15.7 14-18.3 24.2l-4.4 17.6c-5.3 21.1-24.2 35.9-46 35.9c-26.2 0-47.4-21.2-47.4-47.4l0-22.7c0-4.9-2.8-9.4-7.2-11.6c-15.2-7.6-24.8-23.2-24.8-40.2l0-15c0-16.3-10.6-30.6-26.1-35.5L86.9 272C65 265.1 47 249.1 37.7 228.1l-3-6.7C32.9 232.7 32 244.2 32 256zm16-83.3l19 42.4c5.6 12.6 16.3 22.2 29.5 26.3l63 19.7c28.9 9.1 48.6 35.8 48.6 66.1l0 15c0 4.9 2.8 9.4 7.2 11.6c15.2 7.6 24.8 23.2 24.8 40.2l0 22.7c0 8.5 6.9 15.4 15.4 15.4c7.1 0 13.3-4.8 15-11.7l4.4-17.6c4.7-18.7 16.8-34.6 33.5-44.2L320 352c9.9-5.7 16.1-16.3 16.1-27.8l0-8.3c0-8.5-3.4-16.6-9.4-22.6l-3.9-3.9c-6-6-14.1-9.4-22.6-9.4l-48.8 0c-9.9 0-19.7-2.4-28.6-6.8l-45.9-22.9c-8.3-4.2-15.1-10.9-19.2-19.2l-.7-1.4c-10.2-20.4-1.9-45.2 18.5-55.4c9.8-4.9 21.1-5.7 31.5-2.2l24.2 8.2c1.4 .5 2.8 0 3.6-1.2c.8-1.1 .7-2.6-.2-3.7l-17.9-21.5c-12.5-15-12.3-36.8 .4-51.6l20.1-23.5c4.4-5.2 5.1-12.5 1.7-18.4L224 34.3C143.8 45.7 77.3 99.7 48 172.7zM352 477.1c0-51.4 41.7-93.1 93.1-93.1l50.9 0 50.9 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9l-218.2 0c-19.3 0-34.9-15.6-34.9-34.9zm32 0c0 1.6 1.3 2.9 2.9 2.9l218.2 0c1.6 0 2.9-1.3 2.9-2.9c0-33.7-27.4-61.1-61.1-61.1l-101.8 0c-33.7 0-61.1 27.4-61.1 61.1zM426.7 232c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zm27.7 16c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z'
      
    ]
  };

  

  
  

  var faLightFileCircleExclamation = {
    prefix: 'fak',
    iconName: 'light-file-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e00e',
      
      'M0 64C0 28.7 28.7 0 64 0L220.1 0C232.8 0 245 5.1 254 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.8c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l232.3 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 64zM224 32.5L224 144c0 8.8 7.2 16 16 16l111.5 0c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2zM288 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm88 56c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm8-120c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64z'
      
    ]
  };

  

  
  

  var faLightFileCircleQuestion = {
    prefix: 'fak',
    iconName: 'light-file-circle-question',
    icon: [
      576,
      512,
      [],
      'e00d',
      
      'M0 64C0 28.7 28.7 0 64 0L220.1 0C232.8 0 245 5.1 254 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.8c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l232.3 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 64zM224 32.5L224 144c0 8.8 7.2 16 16 16l111.5 0c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2zM288 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm48-38.4c0-23 18.6-41.6 41.6-41.6l40.5 0c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6l-23.7 12.5c-1.4 7.4-7.9 12.9-15.7 12.9c-8.8 0-16-7.2-16-16l0-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9l-40.5 0c-5.3 0-9.6 4.3-9.6 9.6l0 6.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.4zM416 432c0-8.8 7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faLightMobileCircleXmark = {
    prefix: 'fak',
    iconName: 'light-mobile-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e009',
      
      'M32 64C32 28.7 60.7 0 96 0L288 0c35.3 0 64 28.7 64 64l0 147.2c-11.4 5.9-22.2 12.9-32 21L320 64c0-17.7-14.3-32-32-32L96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l192 0c2.6 0 5.1-.3 7.5-.9c7.3 8.9 15.4 17.1 24.2 24.4c-9.4 5.4-20.2 8.5-31.8 8.5L96 512c-35.3 0-64-28.7-64-64L32 64zM144 416c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm144-48c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm52.7-59.3c6.2-6.2 16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faLightRocketLaunchUser = {
    prefix: 'fak',
    iconName: 'light-rocket-launch-user',
    icon: [
      640,
      512,
      [],
      'e006',
      
      'M.1 483.7C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2zM1.7 264.8L52.4 163.4c10.8-21.7 33-35.4 57.2-35.4l97.4 0C286.9-3.7 409.5-8.5 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c6.7 36.1 9 83.5-5.4 131.8c-1.8-.1-3.5-.1-5.3-.1c-10.3 0-20.2 1.4-29.7 4c16.8-45.3 15.7-91.5 9.4-127.5c-43.2-7.6-101.1-7.6-154.6 21.8C269 86.7 215.6 146.3 185.5 268.6c12.4 6 23.8 14.1 33.8 24.1c10 9.9 18.1 21.4 24.1 33.8c61.3-15.1 106.9-36.1 140.7-59.8c-.1 1.7-.1 3.4-.1 5.1c0 10.6 1.5 20.9 4.2 30.6c-1.4 .9-2.8 1.7-4.2 2.6l0 62.7c-12 6.8-22.8 15.4-32 25.6l0-71.1c-28 13.4-60.6 25.2-98.4 34.7c1.6 8 2.4 16.1 2.4 24.3l0 88.8 71.4-35.7c-4.5 12.4-7 25.6-7.4 39.5l-72.8 36.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6l-.1-114.8c0-24.7-9.9-48.4-27.3-65.9s-41.2-27.3-65.9-27.3L16 288c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6zM32.2 479.7c16.9-.6 38.4-2.5 59-7.4c23.2-5.5 41.6-13.9 52.6-24.9c21.9-21.9 21.9-57.4 0-79.3s-57.4-21.9-79.3 0c-11 11-19.4 29.4-24.9 52.6c-4.9 20.6-6.8 42-7.4 59zM41.8 256l88.9 0c8.2 0 16.4 .8 24.3 2.4c9.5-37.9 21.2-70.4 34.7-98.4l-80.1 0c-12.1 0-23.2 6.9-28.6 17.7L41.8 256zM319.5 116c10-17.3 28.5-28 48.5-28s38.5 10.7 48.5 28s10 38.7 0 56s-28.5 28-48.5 28s-38.5-10.7-48.5-28s-10-38.7 0-56zM344 144c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24zm8 333.1c0-51.4 41.7-93.1 93.1-93.1l50.9 0 50.9 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9l-218.2 0c-19.3 0-34.9-15.6-34.9-34.9zm32 0c0 1.6 1.3 2.9 2.9 2.9l218.2 0c1.6 0 2.9-1.3 2.9-2.9c0-33.7-27.4-61.1-61.1-61.1l-101.8 0c-33.7 0-61.1 27.4-61.1 61.1zM426.7 232c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zm27.7 16c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z'
      
    ]
  };

  

  
  

  var faLightScrewdriverWrenchUser = {
    prefix: 'fak',
    iconName: 'light-screwdriver-wrench-user',
    icon: [
      640,
      512,
      [],
      'e000',
      
      'M0 432.8c0-21 8.3-41.1 23.2-56L166 233.9 189.1 257 46.2 399.8c-8.7 8.7-13.6 20.6-13.6 32.9c0 25.8 20.9 46.6 46.6 46.6c12.3 0 24.2-4.9 32.9-13.6L227.6 350.2c1.6 12.2 5.2 24.1 10.9 35.3L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8zM4.9 78.6C-2.4 69-1.5 55.5 7 47L47 7c8.6-8.5 22.1-9.4 31.6-2l104 80c5.9 4.5 9.4 11.5 9.4 19l0 64 0 1.3 101.8 102c27.6-18 64.1-16.6 90.3 4.3c1 31.2 14.8 59 36.1 78.7c-.5 .1-1 .2-1.6 .3L368 304c-17.7-17.7-46.3-17.7-64 0s-17.7 46.3 0 64l38 38c-6.4 9.2-11.5 19.4-15.2 30.2l-45.5-45.5c-26.3-26.3-29.6-66.8-10.1-96.8L169.2 192l-1.3 0-64 0c-7.4 0-14.5-3.5-19-9.4l-80-104zM34.6 64.7L107.9 160l52.1 0 0-52.1L64.7 34.6 34.6 64.7zM72 424c0-8.8 7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16s-16-7.2-16-16zM218.3 72.1C246.9 28.6 296.1 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3l0 25.4c0 8.8 7.2 16 16 16l25.5 0c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10 21 15.7 44.5 15.7 69.3c0 .3 0 .7 0 1c-5.3-.8-10.6-1.2-16.1-1.2c-5.6 0-11.2 .4-16.6 1.2c0-.3 0-.7 0-1c0-10.2-1.2-20.2-3.5-29.7l-48.1 48.1c-9.1 9.1-21.5 14.2-34.4 14.2l-25.4 0c-26.8 0-48.6-21.7-48.6-48.6l0-25.4c0-12.9 5.1-25.3 14.2-34.4l48.1-48.1c-9.5-2.3-19.4-3.5-29.7-3.5c-45.3 0-85.2 23.7-107.7 59.5l-26-20zM352 477.1c0-51.4 41.7-93.1 93.1-93.1l50.9 0 50.9 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9l-187 0c-1.5 .1-2.9 .1-4.4 0l-26.9 0c-19.3 0-34.9-15.6-34.9-34.9zm32 0c0 1.6 1.3 2.9 2.9 2.9l218.2 0c1.6 0 2.9-1.3 2.9-2.9c0-33.7-27.4-61.1-61.1-61.1l-101.8 0c-33.7 0-61.1 27.4-61.1 61.1zM426.7 232c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zm27.7 16c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z'
      
    ]
  };

  

  
  

  var faLightSolarSystemUser = {
    prefix: 'fak',
    iconName: 'light-solar-system-user',
    icon: [
      640,
      512,
      [],
      'e007',
      
      'M0 256c0-50.9 14.9-98.4 40.5-138.3C35.1 109.1 32 98.9 32 88c0-30.9 25.1-56 56-56c10.9 0 21.1 3.1 29.7 8.5c3.5 2.2 6.8 4.8 9.7 7.7l.2 .2L139 64.9c3.2 7 5 14.8 5 23.1c0 30.9-25.1 56-56 56c-8.2 0-16-1.8-23.1-5C44 173.1 32 213.1 32 256c0 123.7 100.3 224 224 224c22.3 0 43.8-3.3 64.2-9.3c-.1 1.9-.1 3.8-.2 5.6l0 1.2c.1 8.9 1.9 17.3 5.1 25.1c-22 6.2-45.2 9.4-69.1 9.4C114.6 512 0 397.4 0 256zM64 88c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24S64 74.7 64 88zM96 256c0-88.4 71.6-160 160-160c28.3 0 54.9 7.4 78 20.3c5.4-2.7 11.5-4.3 18-4.3c22.1 0 40 17.9 40 40c0 5.3-1 10.4-3 15.1c7.5 11.2 13.6 23.4 18.2 36.4c-14.5 18.9-23.2 42.6-23.2 68.3c0 20.5 5.5 39.6 15 56C372.7 380.1 318.6 416 256 416c-88.4 0-160-71.6-160-160zM127.7 48.5c4.9 4.9 8.6 10.5 11.3 16.4c-2.8-6.1-6.6-11.7-11.3-16.4zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128c0-24.3-6.8-47-18.5-66.3c-4.2 1.5-8.8 2.3-13.5 2.3c-22.1 0-40-17.9-40-40c0-3.6 .5-7.1 1.4-10.4C296.1 132.9 276.6 128 256 128c-70.7 0-128 57.3-128 128zM148.1 23.8C180.9 8.5 217.5 0 256 0C363.4 0 455.3 66.1 493.3 159.8c-11.3 .3-22.2 2.2-32.4 5.6C426.1 86.8 347.5 32 256 32c-31.4 0-61.4 6.5-88.5 18.2c-4.2-8.8-10-17.1-17.3-24.4c-.7-.7-1.4-1.4-2.1-2zM186.7 216c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zM208 256c0 17.1 9.1 33 24 41.6s33.1 8.6 48 0s24-24.4 24-41.6s-9.1-33-24-41.6s-33.1-8.6-48 0s-24 24.4-24 41.6zM352 477.1c0-51.4 41.7-93.1 93.1-93.1l50.9 0 50.9 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9l-218.2 0c-19.3 0-34.9-15.6-34.9-34.9zm32 0c0 1.6 1.3 2.9 2.9 2.9l218.2 0c1.6 0 2.9-1.3 2.9-2.9c0-33.7-27.4-61.1-61.1-61.1l-101.8 0c-33.7 0-61.1 27.4-61.1 61.1zM426.7 232c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zm27.7 16c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z'
      
    ]
  };

  

  
  

  var faLightTelescopeUser = {
    prefix: 'fak',
    iconName: 'light-telescope-user',
    icon: [
      640,
      512,
      [],
      'e002',
      
      'M2.1 367.9c-4.3-7.6-1.6-17.5 6-21.8s17.4-1.7 21.8 6c10.7 18.7 21.3 37.3 32 56c4.3 7.6 1.6 17.5-6 21.8s-17.4 1.7-21.8-6l-32-56zM52 311.4c-8.5-14.8-3.9-33.8 10.6-43L328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8C446.4-.8 466 4.4 474.8 19.7l96 166.3c.8 1.4 1.5 2.8 2.1 4.3c-14.4-13.6-32.5-23.5-52.6-27.9C495.9 120.2 471.5 78 447.1 35.7L357.9 87.2 418 191.4c-8.3 8.1-15.4 17.5-20.9 27.8l-53.1-92L79.7 295.2l-.1 .1c-.1 0-.1 .1-.1 .1l0 .1 0 .1L134 390l.1 .1c0 .1 .1 .1 .1 .1l.1 0 .1 0 97-52.5C226.7 327.5 224 316 224 304c0-44.2 35.8-80 80-80c28.7 0 53.8 15.1 67.9 37.7l13.4-7.3c-.9 5.7-1.3 11.5-1.3 17.4c0 6.3 .5 12.5 1.5 18.6l-2.4 1.3c.6 4 .9 8.1 .9 12.3c0 22.5-9.3 42.9-24.3 57.4l7.5 17.6c-9.1 7.2-17.2 15.7-24 25.2l-10.9-25.4c-8.8 3.4-18.4 5.2-28.4 5.2s-19.6-1.9-28.4-5.2L222.7 502.3c-3.5 8.1-12.9 11.9-21 8.4s-11.9-12.9-8.4-21l53.1-124.1-97 52.4c-15.2 8.3-34.2 2.9-42.9-12.1L52 311.4zM262.4 280c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24zM352 477.1c0-51.4 41.7-93.1 93.1-93.1l50.9 0 50.9 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9l-204.8 0c-.2 0-.4 0-.6 0l-12.8 0c-19.3 0-34.9-15.6-34.9-34.9zm32 0c0 1.6 1.3 2.9 2.9 2.9l218.2 0c1.6 0 2.9-1.3 2.9-2.9c0-33.7-27.4-61.1-61.1-61.1l-101.8 0c-33.7 0-61.1 27.4-61.1 61.1zM426.7 232c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zm27.7 16c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z'
      
    ]
  };

  

  
  

  var faLightToolboxUser = {
    prefix: 'fak',
    iconName: 'light-toolbox-user',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M0 234.5c0-17 6.7-33.2 18.7-45.2l42.5-42.6c12-12 28.3-18.7 45.3-18.7l21.5 0 0-48c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 48 21.5 0c17 0 33.3 6.7 45.3 18.7l16.7 16.7c-11.3 3-22 7.7-31.6 13.8l-7.8-7.8c-6-6-14.1-9.4-22.6-9.4L368 160l-224 0-37.5 0c-8.5 0-16.6 3.4-22.6 9.4L41.4 211.9c-6 6-9.4 14.1-9.4 22.6L32 320l128 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 128 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 42.9 0c5.7 12 13.5 22.8 22.9 32L352 352l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-128 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32L32 352l0 64c0 17.7 14.3 32 32 32l259.4 0c-2.2 9.1-3.3 18.6-3.4 28.3l0 1.2c0 .8 0 1.7 .1 2.5L64 480c-35.3 0-64-28.7-64-64L0 234.5zM160 80l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 64c-8.8 0-16 7.2-16 16zM352 477.1c0-51.4 41.7-93.1 93.1-93.1l50.9 0 50.9 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9l-218.2 0c-19.3 0-34.9-15.6-34.9-34.9zm32 0c0 1.6 1.3 2.9 2.9 2.9l218.2 0c1.6 0 2.9-1.3 2.9-2.9c0-33.7-27.4-61.1-61.1-61.1l-101.8 0c-33.7 0-61.1 27.4-61.1 61.1zM426.7 232c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zm27.7 16c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z'
      
    ]
  };

  



export {

  faLightEarthAmericasUser,
  

  faLightFileCircleExclamation,
  

  faLightFileCircleQuestion,
  

  faLightMobileCircleXmark,
  

  faLightRocketLaunchUser,
  

  faLightScrewdriverWrenchUser,
  

  faLightSolarSystemUser,
  

  faLightTelescopeUser,
  

  faLightToolboxUser,
  

};
